export const messages = {
  careteam: {
    id: 'header.CareTeam',
    defaultMessage: 'Care Team',
  },
  noCareteam: {
    id: 'careTeam.Grid.NoCareTeam',
    defaultMessage: 'No Care Team members are currently assigned to you.',
  },
};
